<form class="app-form" [formRoot]="form">
  <div class="setup-content" id="step-1">
    <h4>{{ 'MESSAGES.SUGGESTIONS.RESET_YOUR_PASSWORD' | translate }}</h4>
    @if(portal()?.isMerchant) {
    <p>{{ 'MESSAGES.PROMPTS.ENTER_EMAIL_OR_MOBILE1' | translate }}</p>
    } @else {
    <p>{{ 'MESSAGES.PROMPTS.ENTER_EMAIL_OR_MOBILE2' | translate }}</p>
    }

    <!-- BOTH LOGIN METHODS -->
    @if (loginMethod().includes('mobile') && loginMethod().includes('email')) {
    <div ngTabs>
      <ul ngTabList selectionMode="explicit" [(selectedTab)]="active" class="nav nav-tabs">
        <li class="nav-item" role="presentation">
          <button
            type="button"
            ngTab
            value="1"
            #emailTab="ngTab"
            class="nav-link text-left tracking-theme"
            [class.active]="emailTab.selected()"
          >
            {{ 'LABELS.EMAIL' | translate }}
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            type="button"
            ngTab
            value="2"
            #mobileTab="ngTab"
            class="nav-link text-left tracking-theme"
            [class.active]="mobileTab.selected()"
          >
            {{ 'LABELS.MOBILE' | translate }}
          </button>
        </li>
      </ul>

      <div class="tab-content mt-2">
        <div
          ngTabPanel
          value="1"
          #emailPanel="ngTabPanel"
          class="tab-pane fade starting:opacity-0"
          [class.active]="emailPanel.visible()"
          [class.show]="emailPanel.visible()"
        >
          <ng-template ngTabContent>
            <div class="form-group">
              <input
                class="form-control"
                [formField]="form.email"
                placeholder="name@email.com"
                autocomplete="email"
                inputmode="email"
                type="email"
                appFormFieldOnError
              />
            </div>
          </ng-template>
        </div>
        <div
          ngTabPanel
          value="2"
          #mobilePanel="ngTabPanel"
          class="tab-pane fade starting:opacity-0"
          [class.active]="mobilePanel.visible()"
          [class.show]="mobilePanel.visible()"
        >
          <ng-template ngTabContent>
            <div class="form-group">
              <div class="input-group">
                <app-phone-number-input
                  [preferredCountries]="preferredCountries"
                  [initialCountry]="'za'"
                  [separateDialCode]="separateDialCode"
                  [formField]="form.mobile"
                  name="phone"
                >
                </app-phone-number-input>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    } @else {
    <!-- SINGLE LOGIN METHOD -->
    @if (loginMethod().includes('email')) {
    <div class="form-group">
      <label class="col-form-label">{{ 'LABELS.EMAIL_ADDRESS' | translate }}</label>
      <input
        class="form-control"
        [formField]="form.email"
        placeholder="name@email.com"
        type="email"
        autocomplete="email"
        inputmode="email"
        appFormFieldOnError
      />
    </div>
    } @if (loginMethod().includes('mobile')) {
    <div class="form-group">
      <label class="col-form-label">{{ 'LABELS.MOBILE_NUMBER' | translate }}</label>
      <app-phone-number-input
        [preferredCountries]="preferredCountries"
        [initialCountry]="'za'"
        [separateDialCode]="separateDialCode"
        [formField]="form.mobile"
        name="phone"
        appFormFieldOnError
      >
      </app-phone-number-input>
    </div>
    } }

    <div class="form-group mt-6 mb-0 flex justify-end">
      <button [disabled]="form().invalid() || form().submitting()" class="btn btn-gradient" type="submit">
        <span>{{ 'LABELS.SEND_OTP' | translate }}</span>
      </button>
    </div>
  </div>
</form>
